module.exports = __webpack_public_path__ + "img/chain.41b6961b.svg";